export default class SocketData {
  constructor(obj) {
    obj = obj || {};

    this.id = obj.id;
    this.title = obj.title;
    this.message = obj.message;
    this.customerMessage = obj.customerMessage;
    this.userMessage = obj.userMessage;
    this.operationType = obj.operationType;
    this.data = obj.data;
    this.date = obj.date;
    this.customerId = obj.customerId;
    this.receiverId = obj.receiverId;
  }
}
